export const GET_COVID_INFO = "GET_COVID_INFO";
export const GET_DONORS = "GET_DONORS";
export const GET_DONOR_LIST = "GET_DONOR_LIST";
export const GET_IMPACT = "GET_IMPACT";
export const INSERT = "INSERT"
export const GET_ARTWORKS = "GET_ARTWORKS"

export const GET_DOWNLOADS = "GET_DOWNLOADS"